import useWeatherFlowState from "./useWeatherFlowState"
import { get as getWeather } from '../services/WeatherFlow'
import { useCallback, useEffect, useMemo, useState } from "react"

export default function useTempestHistory(stationId, start, end, bucket = 'e') {

    const [fetchingData, setFetchingData] = useState(false)
    const [allObservations, setAllObservations] = useState([])

    // get station metadata
    const { data: station, isBusy: fetchingStation, error } = useWeatherFlowState(
        `/stations/${stationId}`,
        {},
        [stationId])

    const devices = useMemo(() => (station?.stations?.[0]?.devices), [station])

    // The bread and butter of this view
    const fetchObservations = useCallback(async (devices, timeframe, bucket) => {
        // for now, clear all observations on fetch
        // Alternative would be stitching together, but that would require too much extra work for the current scope
        setFetchingData(true)
        setAllObservations([])
        try {
            let buffer = []
            // historical obeservations are stored in the devices
            for (const { device_id } of devices) {
                // retrieve device data using device id
                const { data, error } = await getWeather(
                    `/observations/device/${device_id}`,
                    {
                        ...timeframe,
                        bucket: bucket,   // e = day, b = 5 min
                    },
                )
                // Only process data that exists (duh!)
                if (data) {
                    const { device_id, type, obs } = data
                    if (device_id && type && obs?.length) {
                        buffer = [
                            ...buffer,
                            data
                        ]
                    }
                }
            }
            setAllObservations(buffer)
        }
        catch (e) {
            log.error(e)
        }
        finally {
            setFetchingData(false)
        }
    }, [])

    const isBusy = useMemo(() => {
        return fetchingStation || fetchingData
    }, [fetchingStation, fetchingData])

    useEffect(() => {
        //console.log('FETCHING TEMPEST HISTORY')
        if (devices?.length && start && end) {
            fetchObservations(devices, { time_start: start, time_end: end }, bucket)
        }
    }, [devices, start, end, bucket])

    return {
        allObservations,
        isBusy,
    }
}